import { mainSiteUrl } from "@/mocks/categories";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20minimalist%20flat%20lay%20assortment%20of%20contemporary%20fashion%20items%20sneakers%20hoodies%20caps%20bags%20and%20accessories%20scattered%20organically%20on%20bright%20white%20surface%20soft%20natural%20daylight%20from%20large%20window%20gentle%20shadows%20warm%20cream%20and%20beige%20undertones%20editorial%20lifestyle%20photography%20clean%20modern%20aesthetic%20airy%20atmosphere%20professional%20composition%20high%20detail&width=1800&height=1000&seq=hero-superbuy-v2-2026-06&orientation=landscape"
          alt="Superbuy Spreadsheet fashion collection flat lay"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center pt-20 pb-10">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-md border border-background-50/20 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500"></span>
          <span className="text-xs font-medium text-background-50 tracking-wide">Updated June 2026</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-extrabold text-background-50 leading-tight max-w-4xl">
          Best Superbuy<br />
          <span className="text-primary-300 font-semibold">Spreadsheet 2026</span>
        </h1>

        <p className="mt-6 text-base md:text-lg text-background-50/85 max-w-2xl leading-relaxed">
          Discover the latest Superbuy Spreadsheet resources, trusted seller lists, and complete buying guides.
          Find verified products, compare options, and shop smarter with our regularly updated spreadsheet collection.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            Superbuy Spreadsheet
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-background-50 text-foreground-950 rounded-full text-base font-semibold hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            Buy It Now
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}